/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ProgramPeriod } from '../../models/program-period';

export interface FindOneAdminProgramPeriod$Params {
  id: string;
}

export function findOneAdminProgramPeriod(
  http: HttpClient,
  rootUrl: string,
  params: FindOneAdminProgramPeriod$Params,
  context?: HttpContext
): Observable<StrictHttpResponse<ProgramPeriod>> {
  const rb = new RequestBuilder(rootUrl, findOneAdminProgramPeriod.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ProgramPeriod>;
    })
  );
}

findOneAdminProgramPeriod.PATH = '/admin/program-periods/{id}';
